"use client";
import { useState } from "react";
import Link from "next/link";
import { HeartIcon } from "lucide-react";

import { PreviewCarousel } from "./preview-carousel";
import { Button } from "@/components/ui/button";
import PriceWithDiscount from "./price-with-discount";
import { Badge } from "../ui/badge";
import { ProductListItemVM } from "@/types/product-ui.types";

type ProductCardProps = {
  product: ProductListItemVM;
};

const ProductCard = ({ product }: ProductCardProps) => {
  const [current, setCurrent] = useState(0);

  const changeSlideByIndex = (index: number) => {
    setCurrent(index);
  };

  const isDiscounted =
    product.colors[current]?.priceCents &&
    product.colors[current]?.priceCents < product.basePriceCents;

  return (
    <Link
      href={`/product/${product.slug}?color=${product.colors[current]?.name}`}
      passHref
      className="block border border-transparent rounded p-2 border-transparent hover:border-gray-200 hover:shadow-lg transition-all duration-300 group"
    >
      <div className="w-full relative">
        {/* Sale Badge */}
        {isDiscounted && (
          <Badge variant="destructive" className="absolute top-2 left-2 z-10">
            Sale
          </Badge>
        )}

        {/* Favorites */}
        <Button
          variant="icon"
          className="absolute top-2 right-2 z-10 p-1 bg-white rounded-full hover:bg-gray-100 transition-colors hover:text-red-600"
          aria-label="Add to favorites"
          data-slot="button"
          size="icon"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            // TODO
            console.log("Add to favorites clicked");
          }}
        >
          <HeartIcon />
        </Button>

        {/* Image */}
        <PreviewCarousel
          productColors={"colors" in product ? product.colors : []}
          current={current}
          changeSlideByIndex={changeSlideByIndex}
        />
        {/* Content */}
        <div className="text-sm">
          <strong aria-label="Product name" className="break-all block truncate">
            {product.name}
          </strong>
          <p className="text-muted-foreground">{product.shortDescription}</p>

          <PriceWithDiscount
            priceCents={product.basePriceCents}
            discountPriceCents={product.colors[current]?.priceCents}
          />
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
